import * as echarts from "echarts"
import EChartsController from "../../echarts_controller"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
    startDate: String,
    endDate: String,
    color: String,
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)
    this.renderChart(
      this.chart,
      this.dataValue,
      this.startDateValue,
      this.endDateValue,
      this.colorValue,
    )
  }

  renderChart(chart, data, startDate, endDate, color) {
    chart.setOption({
      grid: { left: 8, right: 8, top: 16, bottom: 8, containLabel: true },
      tooltip: {
        trigger: "axis",
        confine: true,
        axisPointer: {
          label: {
            formatter: (params) =>
              new Date(params.value).toISOString().split("T")[0],
          },
        },
      },
      xAxis: {
        type: "time",
        min: startDate,
        max: endDate,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: "#B6C7D8", fontSize: 11 },
      },
      yAxis: {
        type: "value",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: "#B6C7D8", fontSize: 11 },
        splitLine: {
          lineStyle: { color: "rgba(255,255,255,0.08)", type: "dashed" },
        },
      },
      series: [
        {
          type: "line",
          smooth: true,
          showSymbol: false,
          data,
          lineStyle: { color, width: 3 },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: color + "66" },
              { offset: 1, color: color + "00" },
            ]),
          },
          itemStyle: { color },
        },
      ],
    })
  }
}
